import { Map, Marker, NavigationControl, FullscreenControl } from "mapbox-gl"

import init from "../../shared/utils/init"

init(() => {
  const els = document.querySelectorAll(`.contact-page-location__map`)
  if (!els.length) return

  els.forEach((el) => {
    const coordinates = el.dataset.coordinates.split(`,`)

    const map = new Map({
      container: el,
      accessToken: `pk.eyJ1Ijoib2RkY2FtcCIsImEiOiJja2w5NzF0cWgwbXdxMnBydjA1angwZWt1In0.46134emdokQYXY2WwM2Pvw`,
      style: `mapbox://styles/oddcamp/ckl97jksi0o4f17nrdi7mbnnf`,
      center: coordinates,
      zoom: 14,
    })

    // Mapbox names every canvas "Map"; several offices on one page need distinct names.
    const canvas = map.getCanvas()
    if (el.dataset.label) {
      canvas.setAttribute(
        `aria-label`,
        `${el.dataset.label}: ${canvas.getAttribute(`aria-label`)}`
      )
    }

    // Mapbox puts aria-label on a plain <div>, which needs a role to carry it.
    const marker = new Marker({ color: `#d0345a` })
      .setLngLat(coordinates)
      .addTo(map)
    marker.getElement().setAttribute(`role`, `img`)

    map.addControl(new NavigationControl())
    map.addControl(new FullscreenControl())
  })
})
